export default __webpack_public_path__ + "static/media/bvdk-logo-2x.71695c3a.svg";